package com.partejar.app.feature.splash.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.partejar.app.feature.auth.data.repository.AuthRepository
import com.partejar.app.core.session.SessionCoordinator
import com.partejar.app.core.session.SessionDestination
import com.partejar.app.core.session.SessionInvalidException
import com.partejar.app.core.session.SessionTemporarilyUnavailableException
import com.partejar.app.core.session.StoredSessionState
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

// Estado MVI estrito para a navegação inicial
sealed class SplashState {
    data object Loading : SplashState()
    data class Navigate(val destination: SessionDestination) : SplashState()
    data object NavigateToAuth : SplashState()
    data object TemporarilyUnavailable : SplashState()
}

class SplashViewModel(
    private val repository: AuthRepository,
    private val sessionCoordinator: SessionCoordinator,
    private val coroutineScope: CoroutineScope? = null
) : ViewModel() {

    private val _state = MutableStateFlow<SplashState>(SplashState.Loading)
    val state: StateFlow<SplashState> = _state.asStateFlow()

    init {
        verificarSessao()
    }

    fun retry() = verificarSessao()

    private fun verificarSessao() {
        (coroutineScope ?: viewModelScope).launch {
            _state.value = SplashState.Loading
            when (repository.storedSessionState()) {
                StoredSessionState.NONE -> _state.value = SplashState.NavigateToAuth
                StoredSessionState.LEGACY -> {
                    sessionCoordinator.clearLocalSession()
                    _state.value = SplashState.NavigateToAuth
                }
                StoredSessionState.RECOVERABLE -> try {
                    _state.value = SplashState.Navigate(sessionCoordinator.resolve())
                } catch (_: SessionInvalidException) {
                    sessionCoordinator.clearLocalSession()
                    _state.value = SplashState.NavigateToAuth
                } catch (_: SessionTemporarilyUnavailableException) {
                    _state.value = SplashState.TemporarilyUnavailable
                } catch (_: Throwable) {
                    _state.value = SplashState.TemporarilyUnavailable
                }
            }
        }
    }
}
